"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * This hook can be used to add horizontal scrolling ability using the mouse wheel to any element.
 * @returns ref object with an wheel event attached to it
 */
const useHorizontalScroll = () => {
    const elRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const el = elRef.current;
        if (el) {
            const onWheel = (e) => {
                if (e.deltaY === 0)
                    return;
                e.preventDefault();
                el.scrollTo({
                    left: el.scrollLeft + e.deltaY,
                    behavior: 'smooth'
                });
            };
            el.addEventListener('wheel', onWheel);
            return () => el.removeEventListener('wheel', onWheel);
        }
    }, []);
    return elRef;
};
exports.default = useHorizontalScroll;
//# sourceMappingURL=useHorizontalScroll.js.map